import { request } from "../../utils/config"
import { loginVariables, login_login } from "./types/login"
import { registerVariables, register } from "./types/register"

type Login = (data: loginVariables) => Promise<login_login | null>
type Register = (data: registerVariables) => Promise<register>

export const LOGIN: Login = async (data) => {
  // Parol URL'da emas, so'rov TANASIDA: URL server va proksi jurnallariga
  // yoziladi. Backend ikkala usulni ham qabul qiladi.
  const response = await request({
    url: "AccountAPI/Login",
    method: "POST",
    data: { email: data.email?.trim() || "", password: data.password || "" },
  })
  return response.data
}

export const REGISTER: Register = async (data) => {
  const response = await request({
    url: "AccountAPI/Register",
    method: "POST",
    data: data,
  })
  return response.data
}

/**
 * Yangi KORXONA ro'yxatdan o'tishi.
 *
 * Eski REGISTER mijoz hisobini ochardi va ko'p korxonali tizimda
 * ishlamaydi: kelgan odam qaysi korxonaning mijozi ekani noma'lum.
 * Endi bu yo'l korxonaning o'zini ochadi.
 */
export const REGISTER_TENANT = async (data: {
  companyName: string
  email: string
  password: string
  confirmPassword: string
  phone?: string
  activationCode?: string
}) => {
  const response = await request({
    url: "Tenants/Register",
    method: "POST",
    data,
  })
  return response.data
}
